import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=d5f598c8&scoped=true&"
import script from "./SuppliersTable.vue?vue&type=script&lang=js&"
export * from "./SuppliersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f598c8",
  null
  
)

export default component.exports